import { AzureSqlDatabaseLinkedService, type IModel, Metamodel, TabularTypeDataset, type IAttribute } from 'shell-models-lib';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.azureSql.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AzureSql_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AzureSql_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: AzureSqlDatabaseLinkedService.MODEL // Linked service redefined
        }
    }
})
export class AzureSqlTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;
    public static DATABASE: IAttribute;
    @Metamodel.attribute({
        display: stringResources.Database,
        templatable: true,
        association: 'DATABASE'
    })
    public database?: string;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
